var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.4902,
    cy: 37.1835,
    r: 36.8359,
    fill: "black",
    fillOpacity: 0.03
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4904 4.09375C55.6964 4.09375 70.4553 18.8527 70.4553 37.0587C70.4553 55.2648 55.6964 70.0237 37.4904 70.0237C19.2843 70.0237 4.52539 55.2648 4.52539 37.0587C4.52539 18.8527 19.2843 4.09375 37.4904 4.09375ZM54.1625 23.8351C52.9817 22.6896 51.159 22.6372 49.9196 23.6527L49.6226 23.9287L32.7186 41.7199L25.4004 33.7084L25.1089 33.4265C23.8894 32.3868 22.066 32.4031 20.8632 33.525C19.6604 34.6469 19.4986 36.4822 20.4269 37.7936L20.6817 38.1097L32.6278 51.1869L54.2552 28.4225L54.5161 28.1115C55.4696 26.8187 55.3434 24.9806 54.1625 23.8351Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckRounded);
export default __webpack_public_path__ + "static/media/check-rounded.5f66ac693bd44f03cf816d5feb93e848.svg";
export { ForwardRef as ReactComponent };